import MovableBox from "./MovableBox";
import usePresentSelector from './usePresentSelector';
import sendImageToServer from './sendImageToServer';
import G from './Getters';
import { useStore } from 'react-redux';
import { useState, useEffect, createRef, useContext } from 'react';
import SvgRendering from './SvgRendering';
import { FIGURE_PANELS } from './RecordTypes';
import Id from './IdFactory';
import { ErrorBoundary } from 'react-error-boundary';
import svgToPng, { blobToBase64URL } from './svgToPngUsingImg';

function asyncSleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function rasterizeMergedImage(svg) {
  console.log('[mi] entering download useEffect');
  let toSave = svg.parentElement;
  let pixelDimsAttribute = svg.querySelector('.merged-image').getAttribute('data-pixelDims');
  let pixelDims = JSON.parse(pixelDimsAttribute || 'null');
  let dims = { width: 720, height: 720, ...pixelDims };
  console.log('[mi] starting replacement');
  const pngBlob = await svgToPng(toSave, dims.width, dims.height);
  debugger;
  const url = blobToBase64URL(pngBlob);
  return url;
}

export default function SvgGrid({
  onClick,
  imageUrlMap: imageUrlMapProp, 
  notifyFinishedDownload,
  format,
  download,
  figurePanelId,
  returnSvgString,
}){

  const store = useStore();
  const state = store.getState();

  let imageUrlMap = imageUrlMapProp ?? {};

  /*
  if( !imageUrlMap ){
    imageUrlMap = getImageUrlMap(state,{figurePanelId});
  }*/

  let exportId = Id();

  if(!figurePanelId){throw Error("figurePanelId cannot be undefined.")}


  let figurePanel = state.data.figurePanels[figurePanelId];

  const svgRef = createRef();

  let cellIdGrid = figurePanel.grid;
  let cellValueMap = figurePanel.cellGroups;

  const filename = G.getFilesystemName(state,{_id:figurePanelId,type:FIGURE_PANELS});

  const [moreImageUrls, setMoreImageUrls] = useState({});

  imageUrlMap = { ...imageUrlMap, ...moreImageUrls };

  let figureDiv = document.getElementById('figure');
  let figureBounds = figureDiv?.getBoundingClientRect();
  let gridItems = Array.from(document.querySelectorAll('td[id^=grid-]'));

  useEffect(() => {
    if( svgRef && svgRef.current && figureDiv ){
      //console.log("SvgGrid useEffect!");

      let svg = document.getElementById('svg-figure');

      let isLocalhost = (
        window.location.href.includes('localhost')
      )
      if (download) {
        function downloadDone() {
          notifyFinishedDownload(/* isLocalhost && svgUrl */);
        }
        if (format === 'svg') {
          async function rasterizeMergedImages() {
            let mergedToBeReplaced = [...document.querySelectorAll('.merged-save-container')];
            const urlMapEntries = await Promise.all(mergedToBeReplaced.map(async el => {
              let url = await rasterizeMergedImage(el);
              console.log("rasterized", url);
              let id = el.getElementsByClassName('merged-image')[0].getAttribute('data-compId');
              return [id, url];
            }));
            const urlMapExtension = Object.fromEntries(urlMapEntries);
            setMoreImageUrls(urlMapExtension);
          }
          async function saveSvg() {
            await asyncSleep(300);
            await rasterizeMergedImages();
            await asyncSleep(300);

            let s = new XMLSerializer();
            let svgData = s.serializeToString(svg);

            if( returnSvgString ){
              notifyFinishedDownload(svgData);
              return;
            }

            let svgBlob = new Blob([svgData], {type:"image/svg+xml;charset=utf-8"});
            sendImageToServer(svgBlob,filename,null,null,"Exported Figure");
            let svgUrl = URL.createObjectURL(svgBlob);
            var downloadLink = document.createElement("a");
            downloadLink.href = svgUrl;
            downloadLink.download = filename + '.svg';
            document.body.appendChild(downloadLink);
            console.trace('$downloadLink.click()');
            downloadLink.click();
            document.body.removeChild(downloadLink);
            downloadDone();
          }
          saveSvg();
        } else if (format === 'png') {
          //let figureAspectRatio = figure.height/figure.height;
          //let figurePixelWidth = 2048;
          const SIZE_CAP = 5000;
          let { width, height } = figureBounds;
          width *= 10;
          height *= 10;
          if (Math.min(width, height) > SIZE_CAP) {
            if (width < height) {
              // width > SIZE_CAP
              let oldWidth = width;
              width = SIZE_CAP;
              height = Math.round(width*(height/oldWidth));
            } else {
              let oldHeight = height;
              height = SIZE_CAP;
              width = Math.round(height*(width/oldHeight));
            }
          }
          svgToPng(svg, figureBounds.width*10, figureBounds.height*10)
            .then(pngBlob => {
              const pngUrl = URL.createObjectURL(pngBlob);
              const a = document.createElement('a');
              a.href = pngUrl;
              a.download = filename + '.png';
              a.click();
            }).then(() => downloadDone())
            .catch(console.error);
        }
      }
    }
  }, []);

  if( !figureDiv ){
    return <div style={{background:'pink'}}>THERE IS NO FIGURE DIV!</div>
  }

  let viewBox = [0,0,figureBounds.width,figureBounds.height].join(' ');
  let [gridX,gridY] = [figureBounds.x, figureBounds.y];




  return (
    <svg style={{
      //border:'3px solid red',
    }} class="outline" ref={svgRef} id={"svg-figure"} viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg">

      


      {false && <style>
        {`
        #error-text:hover {
          fill: blue;
          outline: 3px solid blue;
        }

        .hoverable-image:hover {
          opacity: 0.5;
        }
        `}
      </style>}

      <ErrorBoundary onError={(error,info) => {
        debugger;
        throw(error);
        download && notifyFinishedDownload();
      }} FallbackComponent={()=><div style={{ background:'yellow' }}>ERROR!</div>}>
        {gridItems.map( div => {
          let coord = div.id.split('-').slice(1).map(Number);
          let cellId = cellIdGrid[ coord[0]][ coord[1] ]
          let value = cellValueMap[cellId];

          let divBounds = div.getBoundingClientRect();
          let x = divBounds.x - gridX;
          let y = divBounds.y - gridY;

          return (
            <>
              {true && <SvgRendering 
              onClick={onClick}
              exportId={exportId}
              figurePanel={figurePanel}
              state={state} value={value} div={div} 
              gridOrigin={[gridX,gridY]} 
              cell={coord} imageUrlMap={imageUrlMap} download={download} 
              />}
              {false && <circle cx={x} cy={y} r={3} fill="blue"/>}
            </>
          )
        })}
      </ErrorBoundary>

      {/*<MovableBox/>*/}

    </svg> 
  )



}
